export default {
    type: 'testimonials',
    aliases: {
        camel: 'testimonials',
        singular: 'Testimonial',
        plural: 'Testimonials',
        lowerSingular: 'testimonial',
        lowerPlural: 'testimonials',
    },
    relations: {
        'modules': {
            pivot: {
                type: 'testimonial-modules',
                localKey: 'testimonialId',
                foreignKey: 'moduleId'
            }
        },
        'testimonial-categories': {
            adminLabel: "Categories",
            pivot: {
                type: 'testimonial-testimonial-categories',
                localKey: 'testimonialId',
                foreignKey: 'testimonialCategoryId'
            }
        },
    },
    publishable: true,
    adminSection: 'clients',
    componentType: 'base',
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPublishableCollection',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerTestimonialRecord',
            loader: () => import('./AdministerTestimonialRecord')
        },
        webRecord: {
            name: 'DisplayTestimonialRecord',
            loader: () => import('./DisplayTestimonialRecord')
        },
        webCollectionItem: {
            name: 'TestimonialPoster',
            loader: () => import('./TestimonialPoster')
        }
    },
};
